export default __webpack_public_path__ + "static/media/swa.7c0fb653.svg";